import type { ReactNode } from "react";

/**
 * A section's name in a record or the review's side column: small, subtle,
 * the content under it in ink, the way an admin labels a block without
 * putting a box round it. A count and an action sit on the same line.
 */
export const SectionHeading = ({
  children,
  count,
  action,
}: {
  children: ReactNode;
  count?: number;
  action?: ReactNode;
}) => (
  <div className="flex min-h-6 items-baseline justify-between gap-3">
    <h3 className="text-sm font-medium text-ink">
      {children}
      {count !== undefined && (
        <span className="ps-1.5 font-normal text-subtle tabular-nums">
          {count}
        </span>
      )}
    </h3>
    {action}
  </div>
);
